module.exports = __webpack_public_path__ + "img/topImg2.3d8dc15f.png";